var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "schedulerPreviewModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "overlay" }, [
        _c(
          "div",
          { staticClass: "icon-back-wrapper", on: { click: _vm.hideModal } },
          [_c("div", { staticClass: "icon-back" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title h2-text" }, [
          _vm._v("\n      Scheduler Preview\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "carousel-preview-scheduler" },
          [
            _c(
              "b-button",
              {
                staticClass: "carousel-nav-prev carousel-icon",
                on: { click: _vm.carouselPrevClick }
              },
              [_vm._v("Previous")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "carousel-nav-next carousel-icon",
                on: { click: _vm.carouselNextClick }
              },
              [_vm._v("Next")]
            ),
            _vm._v(" "),
            _vm.currentIndex === 1
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          My Information Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewMyInfoPage", {
                      attrs: {
                        hasFluShot: _vm.allowBookFluShot,
                        hasSpousal: _vm.allowBookForSpouse,
                        spouseLabel: _vm.spouseLabel
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentIndex === 2
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          Select Location Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewSelectLocationPage", {
                      attrs: {
                        landingTopText: _vm.landingTopText,
                        landingBottomText: _vm.landingBottomText
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentIndex === 3
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          My Appointment Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewMyAppointmentPage", {
                      attrs: { landingThankYouText: _vm.landingThankYouText }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cc93c00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc93c00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/preview/SchedulerPreview.vue
// module id = 1651
// module chunks = 1